import { useState } from 'react';
import { tradeNotes as notesApi } from '../api/client';

const MEDIA_BASE = window.location.hostname === 'localhost' ? 'http://localhost:8000' : '';

export default function ScreenshotGallery({ screenshots, sessionId, tradeId, onUpdate }) {
  const [lightboxUrl, setLightboxUrl] = useState(null);
  const [lightboxCaption, setLightboxCaption] = useState('');

  const handleDelete = (noteId) => {
    if (!window.confirm('Delete this screenshot?')) return;
    notesApi.delete(sessionId, tradeId, noteId)
      .then(() => onUpdate())
      .catch((err) => console.error('Failed to delete screenshot:', err));
  };

  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('note_type', 'screenshot');
    formData.append('content', 'Manual upload');
    formData.append('image', file);

    notesApi.create(sessionId, tradeId, formData)
      .then(() => onUpdate())
      .catch((err) => console.error('Failed to upload screenshot:', err));

    e.target.value = '';
  };

  const openLightbox = (screenshot) => {
    setLightboxUrl(`${MEDIA_BASE}${screenshot.image}`);
    setLightboxCaption(screenshot.content || '');
  };

  return (
    <div className="screenshot-gallery">
      <div className="screenshot-grid">
        {screenshots.map((s) => (
          <div key={s.id} className="screenshot-thumb">
            <img
              src={`${MEDIA_BASE}${s.image}`}
              alt={s.content || 'Chart screenshot'}
              onClick={() => openLightbox(s)}
            />
            <div className="screenshot-info">
              <span className="screenshot-label">{s.content}</span>
              <button
                className="screenshot-delete"
                onClick={() => handleDelete(s.id)}
              >
                &times;
              </button>
            </div>
          </div>
        ))}
        <label className="screenshot-upload-btn">
          <input type="file" accept="image/*" onChange={handleUpload} hidden />
          <span>+ Upload</span>
        </label>
      </div>

      {lightboxUrl && (
        <div className="screenshot-modal" onClick={() => setLightboxUrl(null)}>
          <div className="screenshot-modal-content" onClick={(e) => e.stopPropagation()}>
            <img src={lightboxUrl} alt={lightboxCaption} />
            {lightboxCaption && <div className="screenshot-modal-caption">{lightboxCaption}</div>}
            <button className="screenshot-modal-close" onClick={() => setLightboxUrl(null)}>
              &times;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
